import React, { useState } from 'react';
import { 
  Snackbar, 
  Alert, 
  IconButton, 
  Collapse, 
  Box, 
  Typography 
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const ErrorToast = ({ 
  open, 
  onClose, 
  message, 
  details,
  autoHideDuration = 6000,
  anchorOrigin = { vertical: 'top', horizontal: 'center' }
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = (e) => {
    e.stopPropagation();
    setExpanded(!expanded);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        severity="error"
        onClose={onClose}
        sx={{
          width: '100%',
          fontFamily: '"Trasandina Web", Trasandina, sans-serif',
          '& .MuiAlert-message': {
            width: '100%'
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography sx={{ fontWeight: 'bold' }}>{message}</Typography>
          </Box>
          {details && (
            <IconButton
              size="small"
              onClick={handleExpandClick}
              sx={{ 
                ml: 1, 
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s'
              }}
            >
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          )}
        </Box>
        {details && (
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box sx={{ mt: 1, whiteSpace: 'pre-wrap', fontSize: '0.875rem', opacity: 0.8 }}>
              {details}
            </Box>
          </Collapse>
        )}
      </Alert>
    </Snackbar>
  );
};

export default ErrorToast; 